import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { PricingContainer } from '../../components/Pricing'

export const Pricing = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'pricing'} />

      <PricingContainer />
    </>
  )
}
